import { getRangeHours } from './index';

export default {
  computed: {
    elStyl() {
      return this.showSeconds ? { width: '182px' } : { width: '121px' };
    },
    amPmMode() {
      return this.format && this.format.indexOf('A') > -1;
    },
    hours() {
      return this.value && this.value.getHours();
    },
    minutes() {
      return this.value && this.value.getMinutes();
    },
    seconds() {
      return this.value && this.value.getSeconds();
    },
    timeList() {
      return {
        hours: this.filterHours(getRangeHours(this.selectableRange)),
        minutes: this.genList(),
        seconds: this.genList()
      };
    }
  },
  methods: {
    filterHours(hours) {
      const ret = [];
      hours.forEach((disabled, index) => {
        if (!disabled) {
          ret.push(index);
        }
      });
      return ret;
    },
    genList() {
      const ret = [];
      for (let i = 0; i < 60; i++) {
        ret.push(i);
      }
      return ret;
    }
  }
};
